import { createApp } from 'vue'
import VueAMap, {initAMapApiLoader} from '@vuemap/vue-amap';
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@vuemap/vue-amap/dist/style.css'
initAMapApiLoader({
  key: 'edfc0f7c214de16c0b9f1b32c2b9986d',
  securityJsCode: '9ac008c9a0dc8d9935e616b42c228302', // 新版key需要配合安全密钥使用
  //Loca:{
  //  version: '2.0.0'
  //} // 如果需要使用loca组件库，需要加载Loca
})


import { vue3ScrollSeamless } from "vue3-scroll-seamless";
import InfiniteVerticalScroll from './components/VueScroll.vue';
import CountTo from './components/count.vue';

const app = createApp(App);
app.component('InfiniteVerticalScroll', InfiniteVerticalScroll);
app.component('vue3ScrollSeamless', vue3ScrollSeamless);
app.use(store);
app.component('CountTo', CountTo)
//element-plus 中文
app.use(ElementPlus, {  
  locale: zhCn,
})
app.use(VueAMap);
app.use(router);
app.mount('#app');
